
import { Vue, Component, VModel } from 'vue-property-decorator'
import { currencies } from '@/_type/currencies'

@Component({
    inheritAttrs: false,
})
export default class CurrencyAutocomplete extends Vue {
    @VModel() currency!: null | string

    currencies = currencies

    translateCurrency(currency) {
        return this.$te(`currency.${currency.alphabetic}`)
            ? this.$t(`currency.${currency.alphabetic}`)
            : currency.currency
    }
}
